
import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import { getLocaleFromPathname } from "../lib/localeRoutes";

import { localeBackend } from "./localeResources";

export const i18nReady = i18n
  .use(localeBackend)
  .use(initReactI18next)
  .init({
    lng: typeof window === "undefined" ? "en" : getLocaleFromPathname(window.location.pathname),
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: [
      'common',
      'home',
      'howItWorks',
      'whyDocio',
      'contact',
      'errors',
      'legal',
      'about',
      'articles',
      'seo',
      'doctorVisits',
      'locations',
      'pharmacyFinder',
      'resources',
    ],
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false,
    },

    react: {
      useSuspense: false,
    },
  });

export default i18n;
